import React from 'react';
import { useTranslate } from 'react-admin';

import TestResult from './TestResult';
import Definitions from '../../tests/definitions/index';
import { getManualResultKey } from './manualResults';

import './styles.scss';
import {
  getParameterNameForS24,
  getParametersForS24,
} from '../../utils/helpers/partnerParameters';

const TESTS_WITH_STRING_VALUES = [
  'hiv',
  'luesScreen',
  'antiHCV',
  'hbsAntigen',
  'hepatitisB',
  'antiHBC',
  'fecalHemoglobin',
  'hpvGenotyping',
  'gonorrhoea',
  'chlamydia',
  'vdrl',
];

const TestResults = ({
  data,
  partnerCode,
  userInfo,
  manualResults,
  onManualResultChange,
  manualResultErrorKeys,
  readonly,
}: {
  data: any;
  partnerCode: string | null;
  userInfo: any;
  manualResults?: { [key: string]: string };
  onManualResultChange?: (key: string, value: string) => void;
  manualResultErrorKeys?: string[];
  readonly?: boolean;
}) => {
  const translate = useTranslate();
  const isSante24 = partnerCode && partnerCode === 's24';

  return (
    <div>
      <h3 className="title">{translate('testResults.results')}</h3>
      {data.map((result: any) => {
        let testDefinition: any;
        let testName = result.name;
        let testParameters = result.parameters;

        if (isSante24) {
          testName = getParameterNameForS24(result.name);
          testParameters = getParametersForS24(result.parameters, userInfo);
        }

        const isStringValueTest = TESTS_WITH_STRING_VALUES.includes(testName);

        if (isStringValueTest) {
          testDefinition =
            Definitions.stringValues[
              testName as keyof typeof Definitions.stringValues
            ];
        } else {
          testDefinition =
            Definitions.numbericValues[
              testName as keyof typeof Definitions.numbericValues
            ];
        }

        if (!testDefinition) {
          return (
            <div key={result.name}>
              <div className="content">
                <div className="itemWrapper itemWrapper--stringValue itemWrapper--testName">
                  <div className="label">
                    {translate('testResults.parameterName')}
                  </div>
                  <div className="text">{testName}</div>
                </div>
                <div className="itemWrapper">
                  <div className="label">{translate('testResults.result')}</div>
                  <div className="text" style={{ color: '#f52d0a' }}>
                    MISSING definition
                  </div>
                </div>
              </div>
            </div>
          );
        }

        const results = testParameters.map((parameter: any, index: number) => {
          // Key uses stored names, since partner mapping can rename them
          const manualResultKey = getManualResultKey(
            result.name,
            result.parameters[index].name,
          );

          return (
            <TestResult
              data={result}
              testName={testName}
              testParameter={parameter}
              key={parameter.name}
              testDefinition={testDefinition}
              isStringValueTest={isStringValueTest}
              manualResultValue={manualResults?.[manualResultKey]}
              onManualResultChange={
                onManualResultChange &&
                ((value: string) =>
                  onManualResultChange(manualResultKey, value))
              }
              manualResultError={manualResultErrorKeys?.includes(
                manualResultKey,
              )}
              readonly={readonly}
            />
          );
        });

        return results;
      })}
    </div>
  );
};

export default TestResults;
